import { render, staticRenderFns } from "./MedicalCheckupsListComponent.vue?vue&type=template&id=0b0a2b11&"
import script from "./MedicalCheckupsListComponent.vue?vue&type=script&lang=js&"
export * from "./MedicalCheckupsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports